import get from 'lodash/get';

import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';
import { SurveyName } from '@r1-frontend/survey/context/surveys';

import { TButtonType } from '@r1-frontend/ui-react/components/buttons/button';
import { NBSP } from '@r1-frontend/ui-kit/atoms/symbols';

export interface BP42ViewDetails {
    form?: {
        // @todo use ui-kit/button
        buttonType?: TButtonType,
        buttonText?: string,
    },

    popup?: {
        title?: string,
        description?: string,
        specOfferButtonText?: string,
    },

    result?: {
        surveyName?: SurveyName,
    },
}

const getViewDetails = (state: BP42InitialState) => {
    const { viewDetails } = state;

    return {
        form: {
            buttonText: viewDetails?.form?.buttonText || 'Заказать звонок',
            buttonType: viewDetails?.form?.buttonType || 'action',
        },

        popup: {
            // lodash get is used to get an empty value by path.
            // If a property is defined in the store we should not render it (like a hide title from view)
            title: get(viewDetails, 'popup.title', 'Если не хотите заполнять заявку сами'),
            description: get(viewDetails, 'popup.description', `Можно сделать это по${NBSP}телефону. Заодно поможем выбрать роутер.`),
            specOfferButtonText: viewDetails?.popup?.specOfferButtonText || 'Продолжить онлайн',
        },

        result: {
            surveyName: viewDetails?.result?.surveyName,
        },
    };
};

export default getViewDetails;
